import { DeliveryCategory, DeliveryTime, Price } from '~api/api';

import { getPriceRange } from '~src/main/price/price-range';

/*
 * Regular deliveries are probably more important than fast deliveries in FAQ.
 */
const unitPriority: { [key: string]: number } = {
  day: 0,
  business_day: 0,
  hour: 1,
  minute: 2,
  week: 3,
};

function comparePrice(prices: Price[], other: Price[]) {
  const range1 = getPriceRange(prices);
  const range2 = getPriceRange(other);

  const minDiff = range1.min - range2.min;
  if (minDiff !== 0) {
    return minDiff;
  }

  return range1.max - range2.max;
}

function compareDeliveryTime(deliveryTime: Required<DeliveryTime>, other: Required<DeliveryTime>) {
  // put custom text delivery at the bottom.
  if (!!deliveryTime.custom_text !== !!other.custom_text) {
    return !!deliveryTime.custom_text ? 1 : -1;
  }

  // then sort by unit
  const unitDiff = unitPriority[deliveryTime.unit] - unitPriority[other.unit];
  if (unitDiff !== 0) {
    return unitDiff;
  }

  // and then by delivery time range...
  const minDiff = deliveryTime.min - other.min;
  if (minDiff !== 0) {
    return minDiff;
  }

  const maxDiff = deliveryTime.max - other.max;
  return maxDiff;
}

export function compareCategory(category: DeliveryCategory, other: DeliveryCategory) {
  // sort by price first...
  const priceDiff = comparePrice(category.default_prices, other.default_prices);
  if (priceDiff !== 0) {
    return priceDiff;
  }

  return compareDeliveryTime(category.delivery_time as Required<DeliveryTime>, other.delivery_time as Required<DeliveryTime>);
}
